"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicantStatusDetailsToJSON = exports.ApplicantStatusDetailsFromJSONTyped = exports.ApplicantStatusDetailsFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function ApplicantStatusDetailsFromJSON(json) {
    return ApplicantStatusDetailsFromJSONTyped(json, false);
}
exports.ApplicantStatusDetailsFromJSON = ApplicantStatusDetailsFromJSON;
function ApplicantStatusDetailsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'asOfDate': !runtime_1.exists(json, 'asOfDate') ? undefined : (new Date(json['asOfDate'])),
        'applicationId': json['applicationId'],
        'determinationStatus': !runtime_1.exists(json, 'determinationStatus') ? undefined : json['determinationStatus'],
        'name': _1.NameObjectFromJSON(json['name']),
        'statusMessage': !runtime_1.exists(json, 'statusMessage') ? undefined : json['statusMessage'],
        'receipt': !runtime_1.exists(json, 'receipt') ? undefined : _1.ApplicantStatusDetailsReceiptFromJSON(json['receipt']),
    };
}
exports.ApplicantStatusDetailsFromJSONTyped = ApplicantStatusDetailsFromJSONTyped;
function ApplicantStatusDetailsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'asOfDate': value.asOfDate === undefined ? undefined : (value.asOfDate.toISOString().substr(0, 10)),
        'applicationId': value.applicationId,
        'determinationStatus': value.determinationStatus,
        'name': _1.NameObjectToJSON(value.name),
        'statusMessage': value.statusMessage,
        'receipt': _1.ApplicantStatusDetailsReceiptToJSON(value.receipt),
    };
}
exports.ApplicantStatusDetailsToJSON = ApplicantStatusDetailsToJSON;
//# sourceMappingURL=ApplicantStatusDetails.js.map